var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('portal-navbar'),_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view',{staticClass:"px-4 full-height rounded-0 customer-potal-layout",style:(_vm.customColor)})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }